/**
 * Select a cookie by his name
 */
export function getCookie( name: string ): string {
    name = `${name}=`;
    const decodedCookie = decodeURIComponent( document.cookie );
    const ca = decodedCookie.split( ';' );
    for ( let i = 0; i < ca.length; i++ ) {
        let c = ca[ i ];
        while ( c.charAt( 0 ) == ' ' ) {
            c = c.substring( 1 );
        }
        if ( c.indexOf( name ) == 0 ) {
            return c.substring( name.length, c.length );
        }
    }
    return '';
}

/**
 * Simplified document.cookie
 */
export function setCookie( name: string, value: string | number, expireDate?: Date ): void {
    if (!document.cookie.match(/(?:^|;\s*)CookieConsent=/)) {
        return;
    }
    const expires = expireDate !== undefined ? `;expires=${expireDate.toUTCString()}` : '';
    document.cookie = name + '=' + value + expires + ';path=/';
}

export function setCookieConsent() {
    const expires = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = 'CookieConsent={}; expires=' + expires + '; path=/';
}

/**
 * Stores the last known GPS position for 1 hour in the geolocation cookie,
 * so we can tell geolocation permission was granted recently without the unreliable Permissions API
 * Stored as lat_lng_accuracy, which is cookie-safe without url encoding
 */
export function setGpsCookie( lat?: number, lng?: number, accuracy?: number ): void {
    if ( lat !== undefined && lng !== undefined ) {
        const value = `${lat}_${lng}_${accuracy !== undefined ? accuracy : ''}`;
        setCookie( 'geolocation', value, new Date( Date.now() + 60 * 60 * 1000 ) );
    }
}

/**
 * Get the last known GPS position from the geolocation cookie (max 1 hour old)
 * Returns null when the cookie is absent, malformed or misses coordinates
 */
export function getGpsCookie(): { lat: number, lng: number, accuracy?: number } | null {
    const cookie = getCookie( 'geolocation' );
    if ( cookie === '' ) {
        return null;
    }
    const parts = cookie.split( '_' );
    const lat = parseFloat( parts[ 0 ] );
    const lng = parseFloat( parts[ 1 ] );
    const accuracy = parseFloat( parts[ 2 ] );
    if ( !isFinite( lat ) || !isFinite( lng ) ) {
        return null;
    }
    return { lat, lng, accuracy: isFinite( accuracy ) ? accuracy : undefined };
}

/**
 * Remove cookie
 */
export function unsetCookie( name: string ): void {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/';
}

/**
 * Encode text value because of Safari bug: https://stackoverflow.com/questions/45985970/safari-cookie-value-strips-space-after-the-commas
 */
export function setTextCookie( name: string, value: string, expireDate?: Date ): void {
    value = encodeURI( value );
    setCookie( name, value, expireDate );
}

export function getTextCookie( name: string ): string {
    let value = getCookie( name );
    return decodeURI( value );
}